<div style="height: 100vh">
    <div class="notification-bell" *ngIf="checknotif">
      <mat-icon 
        matBadge="{{ getUnreadCount() }}" 
        matBadgeColor="warn" 
        matBadgeHidden="{{ allNotificationsRead() }}"
        class="bells"
        [ngClass]="{'icon-white': colors}"
        (click)="toggleNotificationPanel()">
        circle_notifications
      </mat-icon>
    </div>
    <div *ngIf="isNotificationPanelOpen" class="notification-panel">
      <div class="notification-header">
        <h3>Notificações</h3>
        <div>
          <mat-icon color="primary" *ngIf="notifications.length > 0" (click)="markAllAsRead()" title="Marcar Todos como Lido">mark_email_read</mat-icon>
          <mat-icon color="warn" (click)="toggleNotificationPanel()">
            cancel
          </mat-icon>
        </div>
      </div>
      <div class="notification-list">
        <div class="notification-card" [ngClass]="{'notification-read': !notification.unread}" *ngFor="let notification of notifications">
          <div (click)="notificationRead(notification.id)">
            <div class="notification-header">
              <img src="{{ notification.logo }}" alt="Logo" class="notification-logo">
              <div class="notification-title">{{ notification.title }}</div>
              <div class="notification-time" title="{{ notification.data | date: 'dd/MM/yyyy HH:mm:ss' }}">
                <span>{{ notification.time }}</span>
                <span class="notification-status" [ngClass]="{'unread': notification.unread}"></span>
              </div>
            </div>
            <div class="notification-body">
              <p>
                <!-- Trunca a mensagem se não estiver expandida -->
                {{ notification.isExpanded ? notification.message : (notification.message | slice:0:90) + (notification.message.length > 90 ? ' ...' : '') }}
                <span *ngIf="notification.message.length > 90" (click)="toggleMessage(notification, $event)" class="toggle-message">
                  {{ notification.isExpanded ? 'Leia menos' : 'Leia mais' }}
                  <mat-icon color="primary">
                    {{ notification.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down' }}
                  </mat-icon>
                </span>
              </p>
            </div>
            <div class="notification-footer">
              <!-- <img src="{{ notification.footerIcon }}" class="notification-footer-icon">
              <span>{{ notification.footerText }}</span> -->
            </div>
          </div>
        </div>
      </div>
      <div class="empty-content" *ngIf="notifications.length === 0">
        <span class="mat-body-2">Não há Notificações</span>
    </div>
    </div>
  <router-outlet></router-outlet>
</div>
<app-version-link *ngIf="showVersionLink" customClass="version"></app-version-link> 
